import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import store from '../../redux/store';
import { actions } from "../../redux/actions";
import { assessorMenus, assesseMenus } from "../../shared/utils/constants";
import { AppLogo } from "../../shared/components/ConditonalComponent";
import { logout } from "../../shared/settings/auth";

import './Sidebar.scss';
import { ShieldIcon } from "../../shared/icons/Icons";
import { APP_LOGO_PATH } from "../../shared/settings/config";
export default function Sidebar(props) {

    const dispatch = useDispatch();
    const history = useHistory();

    const loggedInUserData = useSelector((state) => { return state.user });
    const sideBarData = useSelector((state) => state.sidebar);
    const resizeData = useSelector((state) => state.resize );
    const [showLogout, setShowLogout] = useState(false);
 
    // Compute menus directly from Redux state instead of using useState
    // This makes the menu reactive to user data changes (e.g., after page refresh)
    // Check for role in different possible property names
    const userRole = loggedInUserData?.role || loggedInUserData?.user_type || loggedInUserData?.type || loggedInUserData?.userRole;
    const menus = userRole === "user" ? assessorMenus : assesseMenus;
    const isAdmin = userRole === "admin";

    return (
        <aside className={`sidebar-box ${sideBarData.isOpen ? 'mobile-open' : ''}`} onClick={() => { dispatch(actions.setSideBar(false)); }}>
            <nav className="sidebar-content" onClick={(e) => e.stopPropagation()}>
                {/* Logo Section */}
                <div className="sidebar-logo" style={{ cursor: "pointer" }} onClick={() => history.push("/")}>
                    <img
                        className="logo-image"
                        src={APP_LOGO_PATH}
                        alt="App logo"
                        style={{ width: "4.7rem" }}
                    />
                    <div className="logo-content">
                        <div className="logo-title">Civil Vertex Ai</div>
                        <div className="logo-subtitle">by Quantsynx</div>
                    </div>
                </div>
                <div className="d-lg-none d-flex justify-content-end mb-2">
                    <button className="border-0 bg-transparent text-white" onClick={() => dispatch(actions.setSideBar(false))}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </div>
                <ul className="side-menu-container w-100">
                    {
                        menus.map((menu) => {
                            const isActive = props.location.pathname.startsWith(menu.startsWithText);
                            return (
                                <React.Fragment key={menu.name}>
                                    <li className={`menu transition-all ${isActive ? 'active-menu ' : ''}`}>
                                        <Link to={menu.redirectTo} onClick={() => {
                                            store.dispatch(actions.setScreenName(menu.name));
                                            if (resizeData.windowInnerWidth < 1130) {
                                                dispatch(actions.setSideBar(false));
                                            }
                                        }}>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="menu-icon">
                                                    <menu.icon />
                                                </div>
                                                <div className="menu-title">{menu.name}</div>
                                            </div>
                                            {
                                                Array.isArray(menu.submenu) && menu.submenu.length > 0 ? 
                                                <i className={`fa fa-chevron-${isActive ? 'down' : 'right'}`}></i> : ''
                                            }
                                        </Link>
                                    </li>
                                    
                                     {
                                         isActive && menu.submenu?.length > 0 && menu.submenu.map((subMenu) =>
                                             <li key={subMenu.name} className={`${props.location.pathname.startsWith(subMenu.startsWithText) ? 'sub-menu-active-menu ' : 'sub-menu'}`}>
                                                <Link to={subMenu.redirectTo} onClick={() => {
                                                    if (resizeData.windowInnerWidth < 1130) {
                                                        dispatch(actions.setSideBar(false));
                                                    }
                                                }}>
                                                    <div className="d-flex align-items-center gap-2" style={{marginLeft: '1rem'}}>
                                                        <div className="menu-icon">
                                                            <menu.icon />
                                                        </div>
                                                        <div className="menu-title">{subMenu.name}</div>
                                                    </div>
                                                </Link>
                                            </li>
                                        )
                                    }
                                </React.Fragment>
                            );
                        })
                    }
                    {isAdmin && (
                        <>
                            <li className={`menu transition-all ${props.location.pathname.startsWith('/admin') && !props.location.pathname.startsWith('/admin/users') ? 'active-menu ' : ''}`}>
                                <Link to="/admin/dashboard" onClick={() => {
                                    store.dispatch(actions.setScreenName('Admin'));
                                    if (resizeData.windowInnerWidth < 1130) {
                                        dispatch(actions.setSideBar(false));
                                    }
                                }}>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="menu-icon">
                                            <ShieldIcon size={18} />
                                        </div>
                                        <div className="menu-title">Admin Dashboard</div>
                                    </div>
                                </Link>
                            </li>
                            <li className={`menu transition-all ${props.location.pathname.startsWith('/admin/users') ? 'active-menu ' : ''}`}>
                                <Link to="/admin/users" onClick={() => {
                                    store.dispatch(actions.setScreenName('Manage Team'));
                                    if (resizeData.windowInnerWidth < 1130) {
                                        dispatch(actions.setSideBar(false));
                                    }
                                }}>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="menu-icon">
                                            <ShieldIcon size={18} />
                                        </div>
                                        <div className="menu-title">Manage Team</div>
                                    </div>
                                </Link>
                            </li>
                        </>
                    )}
                </ul>
            </nav>

            <div className="sidebar-footer" onClick={(e) => e.stopPropagation()}>
                <div className="d-flex align-items-center justify-content-between profile-footer-icon">
                    <Link to="/profile" className="d-flex align-items-center flex-grow-1 text-decoration-none" onClick={() => {
                        if (resizeData.windowInnerWidth < 1130) {
                            dispatch(actions.setSideBar(false));
                        }
                    }}>
                        <div className="d-flex align-items-center">
                            <div className="user-avatar">
                                {loggedInUserData.first_name?.charAt(0)?.toUpperCase() + loggedInUserData.last_name?.charAt(0)?.toUpperCase() || 'SG'}
                            </div>
                            <div className="d-flex flex-column justify-content-center ms-2 user-info">
                                <div className="user-name">
                                    {loggedInUserData.first_name && loggedInUserData.last_name 
                                        ? `${loggedInUserData.first_name} ${loggedInUserData.last_name}` 
                                        : 'User'}
                                </div>
                                <div className="user-email">
                                    {loggedInUserData.email || 'user@quantsynx.com'}
                                </div>
                            </div>
                        </div>
                    </Link>
                    <div className="chevron-wrapper" onClick={() => setShowLogout(!showLogout)}>
                        <svg className={`chevron-icon ${showLogout ? 'chevron-rotated' : ''}`} width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="6 9 8 11 10 9"></polyline>
                        </svg>
                    </div>
                </div>
                {showLogout && (
                    <button className="logout-btn" onClick={() => logout(history)}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        <span>Logout</span>
                    </button>
                )}
            </div>
        </aside>
    )
}
